export const LIST_USER_OPTIONS = 'LIST_USER_OPTIONS';
export const LIST_USER_OPTIONS_SUCCESS = 'LIST_USER_OPTIONS_SUCCESS';
export const LIST_USER_OPTIONS_FAILED = 'LIST_USER_OPTIONS_FAILED';

export const LIST_GROUP_OPTIONS = 'LIST_GROUP_OPTIONS';
export const LIST_GROUP_OPTIONS_SUCCESS = 'LIST_GROUP_OPTIONS_SUCCESS';
export const LIST_GROUP_OPTIONS_FAILED = 'LIST_GROUP_OPTIONS_FAILED';
